import React from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, CheckOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

export const getElectronicDocumentTitle = (documentType?: string): string => {
  if (documentType === 'CREDIT_NOTE') {
    return 'Nota Crédito Electrónica';
  }
  if (documentType === 'DEBIT_NOTE') {
    return 'Nota Débito Electrónica';
  }
  return 'Factura Electrónica';
};

export const getElectronicCodeLabel = (documentType?: string): string => {
  if (documentType === 'CREDIT_NOTE' || documentType === 'DEBIT_NOTE') {
    return 'CUDE:';
  }
  return 'CUFE:';
};

export const getCopyCodeButtonLabel = (documentType?: string): string => {
  if (documentType === 'CREDIT_NOTE' || documentType === 'DEBIT_NOTE') {
    return 'Copiar CUDE';
  }
  return 'Copiar CUFE';
};

export const getElectronicPdfButtonLabel = (documentType?: string): string => {
  if (documentType === 'CREDIT_NOTE') {
    return 'Descargar Nota Crédito Electrónica (PDF)';
  }
  if (documentType === 'DEBIT_NOTE') {
    return 'Descargar Nota Débito Electrónica (PDF)';
  }
  return 'Descargar Factura Electrónica (PDF)';
};

export const renderElectronicStatusTag = (status?: string | null) => {
  if (status === 'ACCEPTED') {
    return (
      <Tag icon={<CheckCircleOutlined />} color="success" style={{ fontSize: 13, padding: '2px 8px' }}>
        Validada y Aceptada
      </Tag>
    );
  }
  if (status === 'PENDING') {
    return (
      <Tag icon={<ClockCircleOutlined />} color="warning" style={{ fontSize: 13, padding: '2px 8px' }}>
        Pendiente de Validación
      </Tag>
    );
  }
  if (status === 'REJECTED') {
    return (
      <Tag icon={<CloseCircleOutlined />} color="error" style={{ fontSize: 13, padding: '2px 8px' }}>
        Rechazada por DIAN
      </Tag>
    );
  }
  return <Tag color="default">No emitida</Tag>;
};

export const getDocumentStatus = (documentStatus: string) => {
  switch (documentStatus) {
    case 'COMPLETED':
      return 'APROBADO';
    case 'PENDING':
      return 'PENDIENTE';
    case 'APPROVED':
      return 'APROBADO';
    default:
      return 'STATUS';
  }
};

export const renderDeliveryStatusTag = (deliveryStatus?: string | null) => {
  if (deliveryStatus === 'DELIVERED') {
    return (
      <Tag color="blue" icon={<CheckOutlined />} style={{ width: '100%', textAlign: 'center', padding: '3px 0' }}>
        MERCANCÍA ENTREGADA
      </Tag>
    );
  }
  if (deliveryStatus === 'PARTIALLY_DELIVERED') {
    return (
      <Tag color="cyan" icon={<ClockCircleOutlined />} style={{ width: '100%', textAlign: 'center', padding: '3px 0' }}>
        ENTREGA PARCIAL DE MERCANCÍA
      </Tag>
    );
  }
  return (
    <Tag color="volcano" icon={<ClockCircleOutlined />} style={{ width: '100%', textAlign: 'center', padding: '3px 0' }}>
      MERCANCÍA PENDIENTE POR ENTREGAR
    </Tag>
  );
};

export const renderPaymentStatusTag = (paymentStatus?: string | null) => {
  if (paymentStatus === 'PAID') {
    return (
      <Tag color="success" style={{ width: '100%', textAlign: 'center', padding: '4px 0', fontSize: 12 }}>
        PAGADA EN SU TOTALIDAD
      </Tag>
    );
  }
  if (paymentStatus === 'PARTIALLY_PAID') {
    return (
      <Tag color="warning" style={{ width: '100%', textAlign: 'center', padding: '4px 0', fontSize: 12 }}>
        ABONADA (FALTA POR PAGAR)
      </Tag>
    );
  }
  return (
    <Tag color="error" style={{ width: '100%', textAlign: 'center', padding: '4px 0', fontSize: 12 }}>
      PENDIENTE DE PAGO (POR PAGAR)
    </Tag>
  );
};

